export default __webpack_public_path__ + "static/media/dashboard-right.7cd9c947.svg";